import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { Link } from "react-router-dom";
import { sha256 } from "js-sha256";

import { useStore } from "../../store";
import Util from "../../helpers/util";
import Language from "../../helpers/language";
import { AuthenticationType, MemberRole, Notification } from "../../helpers/consts";
import { ConfirmModal } from "../../modals/confirm_modal";
import EmailImg from "../../assets/images/shared/email.svg"
import TrashImage from "../../assets/images/admin/trash.svg"
import DisableImage from "../../assets/images/admin/disable.svg"
import { MembershipModal } from "./membership_modal";
import { Drip7Modal } from "../drip7_modal";


export const UserModal = (props) => {
    const { tenant_uid, tenants, showToast, onAvatar, onShowPoints, onClose } = props

    const [state, setState] = useState({
        info: props.info,
        membership: (props.info.groups != "")? props.info.groups.split(","): [],
        groups: [],
        confirm: null,
        email_intro: true,
        show_groups_modal: false,
    })
    const { info, membership, groups, confirm, email_intro, show_groups_modal } = state

    const tenant = tenants.find( x => x.uid == tenant_uid) || {}

    useEffect(() => {
        //Get a list of all members for this tenant
        Util.fetch_js( "/tenant/details/", { tenant_uid },
            js => {
                setState(prev => ({ ...prev,
                    groups: js.groups,
                }))
            },
            (err, code) => {
                showToast( err.reason, "successful")
            }
        );
    }, [])

    //On input changes, update my info object
    const handleChange = (event) => {
        const new_info = { ...info, [event.target.name]: event.target.value };

        setState(prev => ({ ...prev, info: new_info }))
    }

    //On input checks, update my info object
    const handleChecked = (event) => {
        const new_info = { ...info, [event.target.name]: event.target.checked };

        setState(prev => ({ ...prev, info: new_info }))
    }

    const handleGroupCheck = (group) => {
        const pos = membership.indexOf(group);
        if (pos != -1) {
            membership.splice(pos, 1)
        }
        else {
            membership.push(group)
        }

        setState(prev => ({...prev, membership }))
    }

    const toggleGroupModal = () => {
        setState(prev => ({ ...prev, show_groups_modal: !show_groups_modal }))
    }

    const handleDisableUser = () => {
        const disable = !info.disabled

        //Change disable state on the server
        const payload = {
            user_uids: [info.uid],
            disable,
        };
        Util.fetch_js( "/human/disable/", payload,
            js => {
                onClose()
                showToast(Language.getSentenceCase('updated'), 'successful')

                info.disabled = disabled
                setState(prev => ({ ...prev, info }))
            },
            (reason, code) => {
                showToast(reason, 'failure');
            }
        );

        setState(prev => ({ ...prev, confirm: null }))
    }

    const handleRemoveUser = (valid) => {
        const remove = (info.deleted_on == 0)
        const payload = {
            user_uids: [info.uid],
            remove,
        };
        Util.fetch_js( "/human/remove/", payload,
            js => {
                onClose()
                showToast(Language.getSentenceCase('updated'), 'successful')

                info.deleted_on = remove ? js.deleted_on : 0;
                setState(prev => ({...prev, info }))
            },
            (reason, code) => {
                showToast(reason, 'failure');
            }
        );

        setState(prev => ({ ...prev, confirm: null }))
    }

    const handleSaveChanges = () => {
        let payload = {
            name: info.name,
            nickname: info.nickname,
            email: info.email,
            role: info.role,
            phone: info.phone,
            presentation: info.presentation,
            groups: membership,
            skip_email_intro: !email_intro,
        };

        //Load up the data based on our action
        let endpoint = ""
        let succ = ""
        if ( ('uid' in info) && info.uid != "" ) {
            endpoint = "/human/modify/"
            payload['user_uid'] = info.uid
            succ = `${Language.getSentenceCase("updated")} ${info.name}`
        }
        else {
            endpoint = "/human/create/"
            payload['tenant_uid'] = tenant_uid
            succ = `${Language.getSentenceCase("created")} ${info.name}`
        }

            //Send out the udpate
        Util.fetch_js( endpoint, payload,
            js => {
                onClose()
                showToast(succ, 'successful')
            },
            (reason, code) => {
                showToast(reason, 'failure')
            }
        );
    }

    const handleResetPassword = (action) => {
        //Send out the update
        Util.fetch_js( "/human/forgot/", { email: info.email },
            js => {
                onClose()
                showToast(Language.getSentenceCase('Reset password email sent to') + ": " + info.email)
            },
            (reason, code) => {
                showToast(reason, 'failure')
            }
        );
    }

    const handleToggleEmailIntro = () => {
        setState(prev => ({ ...prev, email_intro: !email_intro }))
    };

    if (groups.length <= 0) {
        groups.push(Language.getSentenceCase('none'));
    }

    //Handle
    const confirmAction = (action) => {
        let yes = null;
        let msg = null;
        if (action == handleRemoveUser) {
            const remove = info.deleted_on == 0;
            yes = (remove ? Language.getTitleCase('remove') + " " : Language.getTitleCase('restore') + " ") + " " + Language.getTitleCase('member');
            msg = (remove ? Language.getTitleCase('remove') + " " : Language.getTitleCase('restore') + " ") + info.name + "?";
        }
        else if (action == handleDisableUser) {
            const disabled = !info.disabled;
            yes = disabled ?  Language.getTitleCase('disable') + " " : Language.getTitleCase('enable')
            msg = (disabled ? Language.getTitleCase('disable') + " " : Language.getTitleCase('enable') + " ") + info.name + "?";
        }
        else {
            throw Language.getSentenceCase('Program error, Unknown action') + ": " + action;
        }

        //Setting a confirm action, will load message box, and if accepted saves
        const new_confirm = { action, msg, yes, no: Language.getTitleCase('cancel') };

        setState(prev =>({...prev, confirm: new_confirm }))
    };

    const disableLabel = info.disabled ? Language.getTitleCase('enable user') : Language.getTitleCase('disable user');
    const removeLabel = info.deleted_on != 0 ? Language.getTitleCase('Restore User') : Language.getTitleCase('remove user');

    //Only show password reset button if this tenant is traditional login
    const existing_user = ('uid' in info)
    const show_pwd_reset = (info.tenant.auth_type == AuthenticationType.USER_PWD) && existing_user
    const title = existing_user? "edit member": 'create member'

    return (
        <div className='personal-info-modal' tabIndex={-1}>
            <Drip7Modal>
                {show_groups_modal && (
                    <MembershipModal 
                        groups={groups} 
                        membership={membership} 
                        handleGroupCheck={handleGroupCheck}
                        onClose={toggleGroupModal}
                    />
                )}
            </Drip7Modal>
            <p className='hidden-heading'>{Language.getTitleCase('dialog content starts')}</p>
            <div className='personal-info-wrap'>
                <div className='personal-info-heading'>
                    <h3>{Language.getTitleCase(title)}</h3>
                    <svg
                        className='close-button'
                        width='12'
                        height='11'
                        viewBox='0 0 12 11'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        onClick={onClose}>
                        <path
                            d='M7.93359 5.375L10.8633 2.44531C11.2441 2.09375 11.2441 1.50781 10.8633 1.15625L10.2188 0.511719C9.86719 0.130859 9.28125 0.130859 8.92969 0.511719L6 3.44141L3.04102 0.511719C2.68945 0.130859 2.10352 0.130859 1.75195 0.511719L1.10742 1.15625C0.726562 1.50781 0.726562 2.09375 1.10742 2.44531L4.03711 5.375L1.10742 8.33398C0.726562 8.68555 0.726562 9.27148 1.10742 9.62305L1.75195 10.2676C2.10352 10.6484 2.68945 10.6484 3.04102 10.2676L6 7.33789L8.92969 10.2676C9.28125 10.6484 9.86719 10.6484 10.2188 10.2676L10.8633 9.62305C11.2441 9.27148 11.2441 8.68555 10.8633 8.33398L7.93359 5.375Z'
                            fill='currentColor'></path>
                    </svg>
                </div>

                <div className='user-photo-and-edit'>
                    <img src={info.profile_url}
                        alt='user avatar'
                         style={{width: '160px', height: '160px'}}
                         onClick={onAvatar}
                    />
                    <div className='edit-user-buttons'>
                        <ul>
                            { !existing_user &&
                                <li className='delete-user'
                                    onClick={handleToggleEmailIntro}>
                                    <input
                                        type='checkbox'
                                        aria-label='checkbox'
                                        readOnly
                                        checked={email_intro}
                                    />
                                    <img src={EmailImg} alt='email image' />
                                    {Language.getTitleCase( 'Email Introduction' )}
                                </li>
                            }
                            {existing_user &&
                                <li className='disable-user'
                                    onClick={onShowPoints}>
                                    <svg width="15" height="15" viewBox="0 0 48 48"
                                         fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill='var(--drip7-primary-color)'
                                              d="M31.0314 31.5926C31.9786 31 32.2701 29.3704 33.0716 28.4815C33.946 27.6667 35.549 27.4444 36.1319 26.4074C36.7148 25.3704 36.1319 23.8148 36.4234 22.6296C36.7148 21.5185 37.9535 20.4815 37.9535 19.2222C37.9535 18.037 36.6419 17 36.3505 15.8889C36.059 14.7037 36.6419 13.1481 36.059 12.1111C35.4761 11.0741 33.8731 10.8519 33.0716 10.037C32.1972 9.14815 31.9786 7.51852 30.9585 6.92593C29.9384 6.33333 28.4083 6.92593 27.2425 6.62963C26.2224 6.33333 25.2023 5 24.0364 5C22.7977 5 21.7776 6.33333 20.6847 6.62963C19.5188 6.92593 17.9887 6.33333 16.9686 6.92593C16.0214 7.51852 15.7299 9.14815 14.9284 10.037C14.054 10.8519 12.451 11.0741 11.8681 12.1111C11.2852 13.1481 11.8681 14.7037 11.5766 15.8889C11.2852 17 10.0465 18.037 10.0465 19.2222C10.0465 20.4815 11.2852 21.5185 11.5766 22.6296C11.8681 23.8148 11.2852 25.3704 11.8681 26.4074C12.451 27.3704 14.054 27.6667 14.9284 28.4815C15.7299 29.3704 15.9485 31 16.9686 31.5926C17.9887 32.1852 19.5188 31.5926 20.6847 31.8889C21.7776 32.1852 22.7977 33.4444 24.0364 33.4444C25.2023 33.4444 26.2224 32.1852 27.3153 31.8889C28.4812 31.5926 30.0113 32.1852 31.0314 31.5926ZM18.2073 19.2222C18.2073 15.963 20.7575 13.2963 24.0364 13.2963C27.2425 13.2963 29.8656 15.963 29.8656 19.2222C29.8656 22.5556 27.2425 25.1481 24.0364 25.1481C20.7575 25.1481 18.2073 22.5556 18.2073 19.2222ZM10.1194 37.1481C9.90077 37.7407 9.97363 38.4074 10.4108 38.9259C10.848 39.4444 11.5038 39.6667 12.0867 39.5185L15.3656 38.8519L16.9686 41.963C17.2601 42.5556 17.843 42.9259 18.4988 42.9259C18.5716 42.9259 18.5716 42.9259 18.5716 42.9259C19.3003 42.9259 19.8832 42.4815 20.1018 41.8889L22.5791 35.8148C18.6445 35.4444 15.147 33.6667 12.5239 31.0741L10.1194 37.1481ZM35.4761 31.0741C32.853 33.6667 29.3555 35.4444 25.4209 35.8148L27.8254 41.8889C28.1168 42.4815 28.6997 42.9259 29.4284 43C29.4284 42.9259 29.4284 42.9259 29.5012 42.9259C30.157 42.9259 30.7399 42.6296 31.0314 41.963L32.6344 38.8519L35.9133 39.5185C36.4962 39.6667 37.152 39.4444 37.5892 38.9259C38.0264 38.4074 38.0992 37.7407 37.8806 37.1481L35.4761 31.0741Z" />
                                    </svg>
                                    {Language.getTitleCase( 'edit points' )}
                                </li>
                            }
                            {existing_user &&
                                <li className='delete-user'
                                    onClick={() => confirmAction( handleRemoveUser )}>
                                    <img src={TrashImage} alt='trash image' />
                                    {removeLabel}
                                </li>
                            }
                            {existing_user &&
                                <li className='delete-user'
                                    onClick={() => confirmAction( handleDisableUser )}>
                                    <img src={DisableImage} alt='disable image' />
                                    {disableLabel}
                                </li>
                            }
                        </ul>
                    </div>
                </div>

                <div className='user-edit-inputs'>
                    <div className='input-wrap'>
                        <label htmlFor='fname'>
                        <span className='tool-tip__container'>
                                    <span className="tool-tip__text">
                                        {Language.getSentenceCase("users name, generally used only if nickname is not available")}
                                    </span>
                            {Language.getTitleCase('Full name')}
                        </span>
                        </label>
                        <input
                            type='text'
                            name='name'
                            placeholder={`${Language.getTitleCase('example')}: Sarah Smith`}
                            onChange={handleChange}
                            value={info.name}
                        />
                    </div>

                    <div className='input-wrap'>
                        <label htmlFor='lname'>
                        <span className='tool-tip__container'>
                                    <span className="tool-tip__text">
                                        {Language.getSentenceCase("what to display for a user, including on the leaderboard")}
                                    </span>
                            {Language.getTitleCase('nickname')}
                        </span>
                        </label>
                        <input
                            type='text'
                            name='nickname'
                            placeholder={Language.getSentenceCase('enter a Nickname')}
                            onChange={handleChange}
                            value={info.nickname}
                        />
                    </div>

                    <div className='input-wrap'>
                        <label htmlFor='email'>
                        <span className='tool-tip__container'>
                                    <span className="tool-tip__text">
                                        {Language.getSentenceCase("used for login and for phishing campaigns")}
                                    </span> 
                            {Language.getTitleCase('email')}
                        </span>
                        </label>
                        <input
                            type='email'
                            name='email'
                            placeholder={'email@address.com'}
                            onChange={handleChange}
                            value={info.email}
                        />
                    </div>

                    {show_pwd_reset && (
                        <div className='password-wrap'>
                            <button
                                className='reset-password solid-button'
                                onClick={handleResetPassword}>
                                {Language.getTitleCase('Reset Password')}
                            </button>
                        </div>
                    )}


                    <div className='input-wrap'>
                        <label htmlFor='department'>
                        <span className='tool-tip__container'>
                                    <span className="tool-tip__text">
                                        {Language.getSentenceCase("what groups does this user belong to")}
                                    </span>
                            {Language.getTitleCase('groups')}
                        </span>
                        </label>
                        <button className='clear-button' onClick={toggleGroupModal}>
                            { membership.length.toString() + " " + Language.getString('selected') }
                        </button>
                    </div>

                    <div className='input-wrap'>
                        <label htmlFor='access'>
                        <span className='tool-tip__container'>
                                    <span className="tool-tip__text">
                                        {Language.getSentenceCase("sets user permission level")}
                                    </span>
                            {Language.getTitleCase('access level')}
                        </span>
                        </label>
                        <DropdownButton title={info.role} name='access'>
                            {Object.entries(MemberRole).map(([key, role]) => (
                            <Dropdown.Item
                                as='button'
                                key={'member_role_'+ key}
                                onClick={handleChange}
                                id='role'
                                name='role'
                                value={role}>
                                {Language.getTitleCase(role)}
                            </Dropdown.Item>
                            ))}
                        </DropdownButton>
                    </div>

                    <div className='input-wrap'>
                        <label htmlFor='access'>
                        <span className='tool-tip__container'>
                                    <span className="tool-tip__text">
                                        {Language.getSentenceCase("sets user notifications")}
                                    </span>
                            {Language.getTitleCase('notifications')}
                        </span>
                        </label>
                        <DropdownButton id="notify" title={Language.getTitleCase(info.notify)}>
                            {Object.entries(Notification).map( ([key, value]) => (
                                <Dropdown.Item
                                    as='button'
                                    onClick={handleChange}
                                    name="notify"
                                    id="notify"
                                    key={key}
                                    value={value}>
                                    {Language.getTitleCase(value)}
                                </Dropdown.Item>
                            ))}
                        </DropdownButton>
                    </div>

                    {tenant.presentation &&
                        <div className='customization-checkbox'>
                            <input
                                type='checkbox'
                                aria-label="checkbox"
                                name='presentation'
                                readOnly
                                id='presentation'
                                onChange={handleChecked}
                                checked={info.presentation}
                            />
                            <span className='checkmark'></span>
                            <label htmlFor='presentation'>
                                {Language.getTitleCase('Presentation user')}
                            </label>
                        </div>
                    }
                </div>

                <div className='save-changes-buttons'>
                    <button className='clear-button' onClick={onClose}>
                        {Language.getTitleCase('cancel')}
                    </button>
                    <button
                        className='save-changes solid-button'
                        onClick={handleSaveChanges}>
                        {Language.getTitleCase('Save Changes')}
                    </button>
                </div>

                {confirm != null && (
                    <ConfirmModal
                        msg={confirm.msg}
                        yesTxt={confirm.yes}
                        noTxt={confirm.no}
                        onYes={() => confirm.action(true)}
                        onNo={() => setState(prev => ({ ...prev, confirm: null })) }
                    />
                )}
            </div>
            <p className='hidden-heading'>{Language.getTitleCase('dialog content ends')}</p>
        </div>
    );
}
